const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manager dashboard component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('managerDashboard', ['Application', 'Authorization', 'Managers', '$location', function (Application, Authorization, Managers, $location) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../../../templates/directives/manager/manager-dashboard.html'),
    controller: ['$scope', 'Users', 'Assignments', function ($scope, Users, Assignments) {
      var self = this;
      self.features = Application.features.flags();
      self.user = Authorization.getAuthToken().user;
      self.manager = self.user;
      self.activeTab = 'users';
      self.assignmentContent = null;
      self.assignmentType = null;
      self.managerConfiguration = null;
      self.usersInitial = false;
      self.singleUser = null;
      self.assignmentsV2 = self.features.enable_assignment_view_v2;

      self.permissions = {
        assign: false,
        createUser: false,
        editUser: false,
        editAssignment: false,
        completeAssignment: false,
        removeAssignment: false
      };

      self.information = {
        allowStats: false,
        users: [],
        userIds: [],
        userList: true,
        stats: {
          total_users: 0,
          open_assignments: 0,
          past_due_assignments: 0,
          completed_since_assignments: 0
        },
        newYearFormat: moment().date(1).month(0).format("MMM YYYY"),
        get: function() {
          if (!self.manager.is_manager) {
            Application.navigation.goTo('/explore');
            return;
          }

          Managers.dashboardStats({subresource: self.manager._id}).$promise
          .then(function(results) {
            self.information.stats = results;
            self.information.userIds = results.users;
            self.information.userList = results.users.join(',');
            self.information.allowStats = true;
          });
        }
      };

      self.creating = {
        previousTab: null,
        select: function() {
          self.creating.previousTab = self.activeTab;
          self.activeTab = 'creating';
        },
        cancel: function() {
          self.activeTab = self.creating.previousTab || 'users';
        },
        onCreate: function() {
          self.creating.cancel();
        }
      }

      self.assign = {
        assigning: false,
        cancel: function() {
          self.assign.assigning = false;
        }
      };

      self.links = {
        assignments: Application.API + '/learn/v3/managers/' + self.manager._id + '/assignments-report' + '?authtoken=' + Authorization.getAuthToken().authtoken,
        users: Application.API + '/learn/v3/managers/' + self.manager._id + '/users-report' + '?authtoken=' + Authorization.getAuthToken().authtoken,
        assessments: Application.API + '/learn/v3/managers/' + self.manager._id + '/assessments-report' + '?authtoken=' + Authorization.getAuthToken().authtoken,
      };

      self.information.get();

      var urlParams = Application.navigation.getUrlParameters();
      if (urlParams.grader) {
        self.activeTab = 'grading';
        self.usersInitial = true;
        $location.url($location.path());
      }

      $scope.$watch('dashboard.manager', function(newVal, oldVal) {
        var oldEmail = oldVal ? oldVal.email : '';
        oldEmail = oldEmail || '';

        if (newVal && newVal.email && newVal.email !== oldEmail) {
          self.information.get();
        }
      });

      self.loaded = false;

      Users.get({subresource: self.user._id, fields: 'first_name,last_name,email,userid,manager_configuration'}).$promise
      .then(function(results) {
        if (!results) {
          self.loaded = true;
          return;
        }

        self.permissions.assign = true;
        self.permissions.completeAssignment = true;
        self.permissions.removeAssignment = true;
        self.permissions.editAssignment = true;

        if (results.manager_configuration) {
          self.managerConfiguration = results.manager_configuration;
          if (results.manager_configuration.disable_assignments) {
            self.permissions.assign = false;
          }
          if (results.manager_configuration.allow_user_creation) {
            self.permissions.createUser = true;
          }
          if (results.manager_configuration.allow_user_edit) {
            self.permissions.editUser = true;
          }
          if (results.manager_configuration.disable_assignment_completion) {
            self.permissions.completeAssignment = false;
          }
          if (results.manager_configuration.disable_assignment_removal) {
            self.permissions.removeAssignment = false;
          }
          if (results.manager_configuration.disable_assignment_edit) {
            self.permissions.editAssignment = false;
          }
          self.loaded = true;

          return;
        }

        self.loaded = true;
        self.permissions.assign = true;

      }).catch(function(error) {
        console.log('error: ', error);
      });

    }],
    controllerAs: 'dashboard'
  };
}]);
